/*
 * @Description: ⽤户参与及好感 – 重点竞品对⽐
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-21 11:02:15
 * @LastEditTime: 2019-03-01 13:54:41
 */

import moment from 'moment';

export default (data, query, typeName) => {
  const [..._data] = data.charts;
  const brandList = _data.pop();
  const xAxis = _data.pop();

  const seriesData = _data.map((item, index) => {
    return {
      name: brandList[index],
      type: 'line',
      data: item
    }
  });

  return {
    color:['#ffd70d','#608f9f','#014d67','#56b5a0','#248e76'],
    legend: {
      show: true,
      data: brandList,
      align: 'left',
      bottom:0,
      orient: 'horizontal'
    },
    xAxis: {
      data: xAxis,
      type: 'category',
    },
    
    yAxis:{
      type: 'value',
    },
    grid: {
      left: -1000,
      
      width: 0,
      heght: 0
    },
    series: seriesData
  };


};


// WEBPACK FOOTER //
// src/chart/competingGoodsLegend.js